import * as React from 'react';

export default class RadioButton extends React.Component {
  render() {
    let selected = this.props.selected;

    return (
      <div
        className={
          'radio-button' +
          (this.props.className ? ' ' + this.props.className : '')
        }
        onClick={(event) => {
          this.props.onClick(event);
        }}
      >
        <div
          className={
            'radio-button-outer' +
            (selected ? ' radio-button-outer-selected' : '')
          }
        >
          <div
            className="radio-button-inner"
            style={{ visibility: selected ? 'visible' : 'hidden' }}
          />
        </div>
        <span className="radio-button-label">{this.props.label}</span>
      </div>
    );
  }
}
